import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7435km15nr: FaireBrandEntity = {
  token: "b_7435km15nr",
  type: "brand",
  name: "Klesis",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9c795114585b617fb36597ce3b631ba96c0b2d4dd3dd1798bb6861d333d006f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/657110427d5207d6096e5986623952a25066d49cd15cec6374700b91d5df0e2d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9c795114585b617fb36597ce3b631ba96c0b2d4dd3dd1798bb6861d333d006f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/657110427d5207d6096e5986623952a25066d49cd15cec6374700b91d5df0e2d.jpeg",
  location: "90021, CA, USA",
  minimumOrderDollars: 60,
  rating: 4.7,
  reviewCount: 184,
  isInsider: true,
  description:
    "A leading player in the fashion industry, Klesis is a renowned lifestyle brand distinguished as a progressive trendsetter. Focusing on premium quality, our highly sought after styles have been a consistent favorite in a constantly changing market. From casual to dressy, we offer a line of quick-to-market women's collection of young contemporary styles that exude femininity and sexiness.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:41.590Z",
    importedBy: "entity-db-cli",
  },
};
